import Urls from "../urlLink";
import { createApiClient, createApiService } from "./apiClientFactory";

const crmClient = createApiClient(Urls.crmApiUrl);
const commonClient = createApiClient(Urls.smcApiUrl);

const crmService = createApiService(crmClient, {
  getGroundPromotion: ["get", "/Sellgoal/getGroundPromotion"],
  getTypeCourseCatApi: ["get", "/Public/getTypeCourseCatApi"],
  getGroundPromotionApi: ["get", "/Public/getGroundPromotionApi"],
  trackRepeatClientAction: ["postForm", "/Intentionclient/trackRepeatClientAction"],
  getChannel: ["get", "/Public/getChannelApi"],
  addStafferSchoolAction: ["postForm", "/Public/addStafferSchoolAction"],
  getSourceApi: ["get", "/Sellgoal/getSourceApi"],
  getSource: ["get", "/Public/getSourceApi"],
  getChannelApi: ["get", "/Sellgoal/getChannelApi"],
  delRepeatAction: ["postForm", "/Client/delRepeatAction"],
  getMarketer: ["get", "/Public/getMarketerApi"],
  setMarketerFollowupOne: ["postForm", "/Client/setMarketerFollowupOne"],
  getNearSchoolApi: ["get", "/Public/getNearSchoolApi"],
  getSchoolOneApi: ["get", "/Api/getSchoolOneApi"],
  getCourseType: ["get", "/CrmStudent/getCourseType"],
  courseTypeRecruitApi: ["get", "/Public/courseTypeRecruitApi"],
  getLabelApi: ["get", "/Public/getLabelApi"],
  addClientTagsAction: ["postForm", "/Client/addClientTagsAction"],
  addCrmStudentTagsAction: ["postForm", "/CrmStudent/addCrmStudentTagsAction"],
  getIntentionLevelList: ["get", "/Public/getIntentionLevelList"],
  ActivityCoursecatApi: ["get", "/PhoneActivity/ActivityCoursecatApi"],
  getSourceTwoApi: ["get", "/Sellgoal/getSourceTwoApi"],
  getChannelTwoApi: ["get", "/Sellgoal/getChannelTwoApi"],
  ComTokenApi: ["get", "/Index/ComTokenApi"],
  ChangePostApi: ["get", "/Index/ChangePostApi"],
  getInvalidnoteApi: ["get", "/Public/getInvalidnoteApi"],
});

const commonService = createApiService(commonClient, {
  getProvince: ["get", "/Common/getProvinceApi"],
  getCity: ["get", "/Common/getCityApi"],
  getAreaApi: ["get", "/Common/getAreaApi"],
});

const storeHttp = Object.assign({}, crmService, commonService);

export default storeHttp;
